/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-12-27 10:52:40
 * @Last Modified by: LiuLiXue
 * @Last Modified time: 2017-12-29 10:53:37
 */
//角色管理接口

import fetch from '@/utils/fetch';
import {shop_url} from '@/global';

// 获得用户列表接口
const getRoleList = (page=1,pageCount=5) => {
  const url = `${shop_url}/shop/cms/smartPark/role/${page}/${pageCount}`;
  return fetch({
    url
  })
}
// 获取角色对应菜单
const getPremiss =(roleId) => {
  const url = `${shop_url}/shop/cms/smartPark/roleMenu/${roleId}`;
  return fetch({
    url
  })
}
// 添加角色
const addRole = (data={},edit=false) => {
  const url = `${shop_url}/shop/cms/smartPark/role`;
  let method = 'post';
  if(edit) {
    method = 'put'
  }
  return fetch({
    url,
    method,
    data
  })
}
// 删除角色
const deleteRole = (roleId) => {
  const url = `${shop_url}/shop/cms/smartPark/role?roleId=${roleId}`;
  const data = {
    roleId,
  };
  const method = 'delete';
  return fetch({
    url,
    method,
  })
}

export {
  addRole,
  getRoleList,
  deleteRole,
  getPremiss
}



// WEBPACK FOOTER //
// ./src/api/permission/roleManage.js